import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 1,
    totalRecord: 0,
    perPage: 0
  },
  sabbaticalCompensateRequest: [],
  sabbaticalCompensateDetail: {}
};

// getters
export const getters = {
  sabbaticalCompensateRequest: state => state.sabbaticalCompensateRequest,
  pagination: state => state.pagination,
  sabbaticalCompensateDetail: state => state.sabbaticalCompensateDetail
};

// mutations
export const mutations = {
  [types.SABBATICAL_COMPENSATE_REQUEST.FETCH_SABBATICAL_COMPENSATE_REQUEST](
    state,
    sabbaticalCompensate
  ) {
    state.sabbaticalCompensateRequest = sabbaticalCompensate;
    state.pagination.from = sabbaticalCompensate.from;
    state.pagination.to = sabbaticalCompensate.to;
    state.pagination.totalPage = sabbaticalCompensate.last_page;
    state.pagination.path = sabbaticalCompensate.path;
    state.pagination.currentPage = sabbaticalCompensate.currentPage;
    state.pagination.perPage = sabbaticalCompensate.per_page;
    state.pagination.totalRecord = sabbaticalCompensate.total;
  },
  [types.SABBATICAL_COMPENSATE_REQUEST.DETAIL_SABBATICAL_COMPENSATE_REQUEST](
    state,
    detailCompensate
  ) {
    state.sabbaticalCompensateDetail = detailCompensate;
  }
};

// actions
export const actions = {
  async fetchCompensateData({ commit }, payload) {
    const response = await axios.get(api.LIST_SABBATICAL_COMPENSATE_REQUEST, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        employee_info: payload.employee_info,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        time_compensate: payload.time_compensate,
        status: payload.status,
        approvePerson: payload.approvePerson,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy
      }
    });
    commit(
      types.SABBATICAL_COMPENSATE_REQUEST.FETCH_SABBATICAL_COMPENSATE_REQUEST,
      response.data.monthlyWorkTimeRequest
    );
  },
  async detailSabbaticalCompensateRequest(
    { commit },
    sabbaticalCompensateRequestId
  ) {
    const response = await axios.get(
      api.DETAIL_SABBATICAL_COMPENSATE_REQUEST +
        "/" +
        sabbaticalCompensateRequestId
    );
    commit(
      types.SABBATICAL_COMPENSATE_REQUEST.DETAIL_SABBATICAL_COMPENSATE_REQUEST,
      response.data.monthlyWorkTimeAdditionalRequest
    );
  }
};
